import carriersMapper from '../mappers/carriersMapper';
import { RETRIEVE_OUTBOUND_CARRIER_SUCCESS } from '../actions/types/CarrierActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

export const initialState = [];

export const outboundCarrierReducer = (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_OUTBOUND_CARRIER_SUCCESS:
      return carriersMapper(action.payload);
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};

